import { PopoverPlacement } from "@idui/react-popover";
import clsx from "clsx";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import { SVG_MUI } from "@ryde/assets";
import { FramerTooltip } from "@ryde/controls";
import { errors, Log } from "@ryde/shared";

interface IDurationLabelExceededProps {
  totalRideDurationDisplayValue: string | number;
  priceRateMaxDurationDisplayValue: string | number;
  isRideOvertimeOnProduceAllowed: boolean;
  isIgnoredMaxDurationForDirectRide?: boolean;
  displayContent: string;
}

export const DurationLabelExceeded: FC<IDurationLabelExceededProps> = ({
  totalRideDurationDisplayValue,
  priceRateMaxDurationDisplayValue,
  isRideOvertimeOnProduceAllowed,
  isIgnoredMaxDurationForDirectRide = false,
  displayContent,
}) => {
  const { t } = useTranslation();
  const additionalInfoParts: string[] = [];

  if (isRideOvertimeOnProduceAllowed) {
    additionalInfoParts.push(
      "allowed on produce by ignoreTimeLimitsForsavedMLRouteUsedForReorders setting",
    );
  }

  if (isIgnoredMaxDurationForDirectRide) {
    additionalInfoParts.push(
      "max duration ignored for direct ride by ignoreMaxDurationForDirectRide setting",
    );
  }

  const additionalInfo =
    additionalInfoParts.length > 0
      ? ` (${additionalInfoParts.join(", ")})`
      : "";

  Log.debug(
    `Total duration exceeded${additionalInfo}, ride duration: ${totalRideDurationDisplayValue}> price rate duration:${priceRateMaxDurationDisplayValue}`,
  );

  const tooltipContent = isIgnoredMaxDurationForDirectRide
    ? t("ride.formLabel.maxDurationIgnoredForDirectRide")
    : t(errors.ride.totalDurationExceeded, {
        rideValue: totalRideDurationDisplayValue,
        priceRateValue: priceRateMaxDurationDisplayValue,
      });

  return (
    <FramerTooltip placement={PopoverPlacement.bottom} content={tooltipContent}>
      <label
        data-e2e="ride-total-duration"
        className={clsx({
          rideTotalDurationLabel_exceeded: true,
          allowed_by_settings: isRideOvertimeOnProduceAllowed,
          direct_ride_ignored: isIgnoredMaxDurationForDirectRide,
        })}
      >
        {!isIgnoredMaxDurationForDirectRide && (
          <SVG_MUI.CircleExclamation className="rideTotalDurationLabel-exclamationIcon" />
        )}
        {displayContent}
      </label>
    </FramerTooltip>
  );
};
